export default "<div *ngIf=\"imageUrl\">\n  <img [src]=\"imageUrl\">\n</div>\n"